var _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    fill: "none",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 50,
    transform: "translate(-13.631938,15.579357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 980,400 c -30,30 -30,100 -30,100 A 450,450 0 1 1 50,500 450,450 0 0 1 500,50 c 50,0 30,-30 100,-30"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 50,
    transform: "translate(-14.316448,15.486955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 489.49426,644.87766 c -84.39138,-84.39132 251.83972,-111.21671 251.83972,-230.56413 0,-119.34742 43.51574,-68.276 127.90711,-152.66738 84.39137,-84.39137 -15.36553,144.73165 103.98189,144.73165"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 50,
    transform: "translate(-14.211282,15.434372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 600.25316,20.253165 c -30,30 -78.68549,269.425505 -78.68549,269.425505 0,119.34742 26.59137,128.64604 -57.8,213.03736 -84.39137,84.39132 157.21526,235.76658 47.91685,283.70052 C 396.23194,837.04946 266.19332,902.58934 181.80195,818.19802 97.410578,733.80669 50,619.34742 50,500 50,380.65258 97.410578,266.19332 181.80195,181.80195 266.19332,97.410578 380.65258,50 500,50 550,50 530,20 600,20"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 30
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 63.539731,642.73155 C 171.187,576.12691 62.73536,465.62985 175.3113,462.24412 225.28871,460.74104 281.26067,255.02893 351.26067,255.02893"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 611.73836,945.66047 C 719.38563,879.05583 655.72464,848.40298 723.50993,765.17304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125.22424,775.73544 C 178.34376,658.49789 245.15989,676.53053 312.94518,593.30059"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 50
    },
    id: "path2710",
    d: "M 565.29652,127.59949 A 360.27264,342.74585 0 0 1 825.49645,288.76293"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logoWhite.03e6146677f703cbf24e8a3a666a6775.svg";
export { ForwardRef as ReactComponent };